import React, { useEffect, useRef, useState } from 'react';
import Badge from 'housecall-ui/dist/DesignSystem/DataDisplay/Badges/Badge';
import Popover from 'housecall-ui/dist/DesignSystem/DataDisplay/Popover/Popover';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Box from 'housecall-ui/dist/DesignSystem/Layout/Box/Box';
import Tab from 'housecall-ui/dist/DesignSystem/Navigation/Tabs/Tab';
import Tabs from 'housecall-ui/dist/DesignSystem/Navigation/Tabs/Tabs';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import useTheme from 'housecall-ui/dist/DesignSystem/Styles/useTheme';
import ExpandMore from 'housecall-ui/dist/IconsAndImages/Icons/ExpandMore';
import PropTypes from 'prop-types';

import { getTotalBadgecount } from './Utils';

const useStyles = makeStyles({
  anchorTopRight: {
    right: -6,
  },
});

const MoreDropdownTab = ({ dropdownList, activeTab }) => {
  const [openMenu, setOpen] = useState(null);
  const theme = useTheme();

  const classes = useStyles();

  const isSelectedTab = dropdownList.some((item) => activeTab === item.value);

  const actionRef = useRef();

  useEffect(() => {
    const timeout = setTimeout(() => {
      actionRef?.current?.updateIndicator();
    }, theme.transitions.duration.shorter);

    return () => {
      clearTimeout(timeout);
    };
  }, [openMenu, theme, actionRef]);

  const handleClick = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  return (
    <>
      <Tab
        version="v2"
        onClick={handleClick}
        label={
          <Typography variant="subtitle2" color="textPrimary">
            More
          </Typography>
        }
        secondary={
          <Badge
            badgeContent={getTotalBadgecount(dropdownList.filter((tab) => tab.badgeCount).map((tab) => tab.badgeCount))}
            color="info"
            version="v2"
            classes={{ anchorOriginTopRightRectangle: classes.anchorTopRight }}
          >
            <ExpandMore size="small" />
          </Badge>
        }
        selected={isSelectedTab}
      />
      <Popover
        anchorEl={openMenu}
        open={Boolean(openMenu)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <Box width="160px" mb={1}>
          <Tabs orientation="vertical" tabSize="sm" action={actionRef} value={activeTab || false} version="v2">
            {dropdownList.map((item, index) => (
              <Tab
                key={index}
                value={item.value}
                version="v2"
                secondary={<Badge color="info" badgeContent={item.badgeCount} version="v2" />}
                href={item.href}
                onClick={item.onClick}
                label={
                  <Typography color="textPrimary" variant="subtitle2">
                    {item.label}
                  </Typography>
                }
              />
            ))}
          </Tabs>
        </Box>
      </Popover>
    </>
  );
};

MoreDropdownTab.propTypes = {
  dropdownList: PropTypes.arrayOf(PropTypes.object),
  activeTab: PropTypes.string.isRequired,
};

export default MoreDropdownTab;
